import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
// import {ContractorWrapper} from '../pages/contractor/addContractor'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  const ContractorPage = lazy(() => import('../modules/contractors/ContractorPage'))
  const ProjectPage = lazy(() => import('../modules/projects/ProjectPage'))
  const ContractorVideoPage = lazy( () => import('../modules/contractorTrainingVideos/ContractorVideoPage'))
  const EmployeeVideoPage = lazy( () => import('../modules/employeeTrainingVideos/EmployeeVideoPage'))
  const MapViewPage = lazy(() => import('../modules/mapViews/MapViewPage'))
  const CalendarViewPage = lazy(() => import('../modules/calendarViews/CalendarViewPage'))
  const MetaDataViewPage = lazy(() => import('../modules/metaData/MetaDataPage'))
  const AllChatPage = lazy(() => import('../modules/chats/AllChatPage'))
  const EmployeePage = lazy(() => import('../modules/employees/EmployeePage'))
  const TimesheetPage = lazy(() => import('../modules/timesheet/TimesheetPage'))
  const StockPage = lazy(() => import('../modules/stock/StockPage'))


  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        {/* <Route path='contractor' element={<ContractorWrapper />} /> */}
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}

        {/* <Route
          path='admin/contractor/*'
          element={
            <SuspensedView>
              <ContractorPage />
            </SuspensedView>
          }
        /> */}
        
         <Route
          path='admin/*'
          element={
            <SuspensedView>
              <ProjectPage />
              <MapViewPage />
              <ContractorPage />
              <EmployeePage />
            </SuspensedView>
          }
        />
          <Route
          path='admin/contractorTrainingVideo/*'
          element={
            <SuspensedView>
              <ContractorVideoPage />
            </SuspensedView>
          }
        />
          <Route
          path='admin/employeeTrainingVideo/*'
          element={
            <SuspensedView>
              <EmployeeVideoPage />
            </SuspensedView>
          }
        />
          {/* <Route
          path='admin/*'
          element={
            <SuspensedView>
              <MapViewPage />
            </SuspensedView>
          }
        /> */}
         <Route
          path='admin/calendarView/*'
          element={
            <SuspensedView>
              <CalendarViewPage />
            </SuspensedView>
          }
        />
         <Route
          path='admin/masterData/*'
          element={
            <SuspensedView>
              <MetaDataViewPage />
            </SuspensedView>
          }
        />

         <Route
          path='admin/chat/*'
          element={
            <SuspensedView>
              <AllChatPage />
            </SuspensedView>
          }
        />

        <Route
          path='admin/timesheet/*'
          element={
            <SuspensedView>
              <TimesheetPage />
            </SuspensedView>
          }
        />

        <Route
          path='admin/stock/*'
          element={
            <SuspensedView>
              <StockPage />
            </SuspensedView>
          }
        />

        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
